// if($('#add-cart-note-gift').length > 0){
//   // console.log("hola");
//   $("#add-cart-note-gift").change(function() {
//     if(this.checked) {
//         //Do stuff
//       console.log("hola");
//       $('.cart__note field').show();
//     }
// });
// }
  /* quitar tag h1 de la modal de la aplicación de guía de tallas */
  // function transformTag(tagIdOrElem, tagType){
  //   console.log("test");
  //   var elem = (tagIdOrElem instanceof HTMLElement) ? tagIdOrElem : document.getElementById(tagIdOrElem);
  //   if(!elem || !(elem instanceof HTMLElement))return;
  //   var children = elem.childNodes;
  //   var parent = elem.parentNode;
  //   var newNode = document.createElement(tagType||"span");
  //   for(var a=0;a<elem.attributes.length;a++){
  //       newNode.setAttribute(elem.attributes[a].nodeName, elem.attributes[a].value);
  //   }
  //   for(var i= 0,clen=children.length;i<clen;i++){
  //       newNode.appendChild(children[0]); //0...always point to the first non-moved element
  //   }
  //   newNode.style.cssText = elem.style.cssText;
  //   parent.replaceChild(newNode,elem);
  //   console.log("test");
  // }
  // transformTag(document.querySelector('#ccpops-popup__recommendation-size-result'), 'div');
// document.addEventListener("DOMContentLoaded", function(event) {
//   transformTag(document.querySelector('#ccpops-popup__recommendation-size-result'), 'div');
// });
// if(document.getElementsByClassName('product-grid').length > 0){
	
// 		// $( "<div class='category-label-shop'><p>SS23 HINT</p></div>" ).insertBefore( "li.post-23163" );
// if(document.getElementsByClassName('collection-all-accessories').length > 0){
//   // $( "<div class='category-label-shop'></p></div>" ).insertBefore( "li.post-23163" );
//   // document.innerHtml("<div class='category-label-shop'></div>");
//   // document.getElementsByClassName('lv-prod-7857830658256').parentElement.insertBefore("keyke");
//     var my_elem = document.getElementsByClassName('lv-prod-7857830658256').parentElement;  
//     var separator = document.createElement('div');
//       separator.className = 'asterisk';  
  
//     // my_elem.insertBefore(separator, my_elem);
//   // document.getElementsByClassName('lv-prod-7857830658256').parentElement.insertAdjacentElement("beforebegin", separator);
//   // document.querySelector( "<div class='category-label-shop'></div>" ).insertBefore( document.getElementsByClassName('lv-prod-7857830658256').parentElement );
// }
//   console.log("hola key key" );
//   const child = document.getElementsByClassName('lv-prod-7857830658256');

// const parentWithClass = child.closest('.parent');
//   console.log(child.closest(".grid__item"));
// }/* Fin titulos categoria new-in*/

// ZC - drosello 21/12/2025
(() => {
  const DRAWER_ID = "lv-qa-drawer"; 
  const t = (key, fallback) => {
    const v = window.LV_QA_I18N && window.LV_QA_I18N[key];
    return (typeof v === "string" && v.trim()) ? v : (fallback || "");
  };

  const getActiveLocale = () => {
    const wl =
      (window.Weglot && typeof Weglot.getCurrentLang === "function" && Weglot.getCurrentLang()) ||
      null;

    return (
      wl ||
      document.documentElement.lang ||
      window.Shopify?.locale ||
      "en"
    );
  };
  
  const getActiveCurrency = () => {
    return (
      window.Shopify?.currency?.active ||
      window.LV_CURRENCY_ISO ||
      window.LV_SHOP_CURRENCY ||
      "EUR"
    );
  };

  const convertCentsIfNeeded = (cents) => {
    const base = window.LV_SHOP_CURRENCY || null;
    const active = getActiveCurrency();

    let n = Number(cents || 0);

    if (!base || base === active) return n;

    const rate = window.Shopify?.currency?.rate;
    if (typeof rate === "number" && isFinite(rate) && rate > 0) {
      return Math.round(n * rate);
    }

    return n;
  };

  const formatMoneyIntl = (cents) => {
    const locale = getActiveLocale();
    const currency = getActiveCurrency();

    const converted = convertCentsIfNeeded(cents);
    const amount = converted / 100;

    try {
      return new Intl.NumberFormat(locale, { style: "currency", currency }).format(amount);
    } catch (_) {
      return new Intl.NumberFormat("en", { style: "currency", currency }).format(amount);
    }
  };


  let lvQaScrollY = 0;

  const lockScroll = () => {
    lvQaScrollY = window.scrollY || 0;
    document.body.style.top = `-${lvQaScrollY}px`;
    document.body.style.position = "fixed";
    document.body.style.left = "0";
    document.body.style.right = "0";
    document.body.style.width = "100%";
  };

  const unlockScroll = () => {
    document.body.style.position = "";
    document.body.style.top = "";
    document.body.style.left = "";
    document.body.style.right = "";
    document.body.style.width = "";
    window.scrollTo(0, lvQaScrollY);
  };


  const ensureDrawer = () => {
    let drawer = document.getElementById(DRAWER_ID);
    if (drawer) return drawer;

    const html = `
      <div class="lv-qa-drawer" id="${DRAWER_ID}" hidden aria-hidden="true">
        <div class="lv-qa-drawer__backdrop" data-lv-qa-close></div>

        <aside class="lv-qa-drawer__panel" role="dialog" aria-modal="true" aria-label="Selecciona talla">

          <div class="lv-qa-gallery" id="lv-qa-gallery" hidden>
          
            <button type="button" class="lv-qa-drawer__close" data-lv-qa-close aria-label="Cerrar">✕</button>
            <div class="lv-qa-gallery__media">
              <img class="lv-qa-gallery__img" id="lv-qa-gallery-img" alt="" />
            </div>

            <button type="button" class="lv-qa-gallery__nav lv-qa-gallery__nav--prev" id="lv-qa-gallery-prev" aria-label="Previous"></button>
            <button type="button" class="lv-qa-gallery__nav lv-qa-gallery__nav--next" id="lv-qa-gallery-next" aria-label="Next"></button>
          </div>

          <div class="lv-qa-drawer__body" id="lv-qa-drawer-body">

            <div class="lv-qa-product-title" id="lv-qa-product-title"></div>
            <div class="lv-qa-price" id="lv-qa-price"></div>

            <div class="lv-qa-opt" id="lv-qa-sizes"></div>

            <div class="lv-qa-desc" id="lv-qa-desc"></div>
          </div>

          <div class="lv-qa-drawer__footer">
            <button type="button" class="lv-qa-drawer__add button button--full-width" id="lv-qa-drawer-add" disabled>
              ` + t("add_to_cart", "Add to cart"); + `
            </button>
          </div>
        </aside>
      </div>
    `;


    document.body.insertAdjacentHTML("beforeend", html);
    drawer = document.getElementById(DRAWER_ID);

    drawer.addEventListener("click", (e) => {
      const panel = drawer.querySelector(".lv-qa-drawer__panel");
      if (!panel) return;

      if (e.target.closest("[data-lv-qa-close]")) {
        closeDrawer();
        return;
      }

      if (!panel.contains(e.target)) {
        closeDrawer();
      }
    });


    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape" && !drawer.hidden) closeDrawer();
    });

    return drawer;
  };

  const openDrawer = () => {
    const drawer = ensureDrawer();
    drawer.hidden = false;
    document.documentElement.classList.add("lv-qa-open");
    drawer.classList.add("is-open");
    drawer.setAttribute("aria-hidden", "false");
    lockScroll();
  };

  const closeDrawer = () => {
    const drawer = document.getElementById(DRAWER_ID);
    if (!drawer) return;

    drawer.classList.remove("is-open");
    drawer.hidden = true;

    document.documentElement.classList.remove("lv-qa-open");
    drawer.setAttribute("aria-hidden", "true");
    unlockScroll();

    const titleEl = drawer.querySelector("#lv-qa-product-title");
    const priceEl = drawer.querySelector("#lv-qa-price");
    const sizesEl = drawer.querySelector("#lv-qa-sizes");
    const descEl  = drawer.querySelector("#lv-qa-desc");
    const gallery = drawer.querySelector("#lv-qa-gallery");
    const addBtn  = drawer.querySelector("#lv-qa-drawer-add");

    if (titleEl) titleEl.textContent = "";
    if (priceEl) priceEl.textContent = "";
    if (sizesEl) sizesEl.innerHTML = "";
    if (descEl)  descEl.innerHTML = "";
    if (gallery) gallery.hidden = true;
    if (addBtn)  addBtn.disabled = true;

    drawer.dataset.lvSelectedVariant = "";

  };
  
  const postAddToCart = async (variantId, quantity = 1) => {
    const res = await fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({ id: Number(variantId), quantity: Number(quantity) }),
    });

    if (!res.ok) {
      let msg = "No se pudo añadir al carrito.";
      try {
        const err = await res.json();
        if (err?.description) msg = err.description;
      } catch (_) {}
      throw new Error(msg);
    }

    // document.dispatchEvent(new CustomEvent("cart:refresh"));
    // document.dispatchEvent(new CustomEvent("cart:open"));

    return res.json();
  };

  const fetchProductJson = async (handle) => {
    const res = await fetch(`/products/${handle}.js`, { headers: { "Accept": "application/json" } });
    if (!res.ok) throw new Error("No se pudo cargar el producto.");
    return res.json();
  };

  const getArrowSvg = () => {
    const tpl = document.getElementById("lv-icon-arrow-tpl");
    return tpl ? tpl.innerHTML.trim() : "";
  };

  const setupGallery = (drawer, product) => {
    const wrap = drawer.querySelector("#lv-qa-gallery");
    const img = drawer.querySelector("#lv-qa-gallery-img");
    const prev = drawer.querySelector("#lv-qa-gallery-prev");
    const next = drawer.querySelector("#lv-qa-gallery-next");

    const images = Array.isArray(product.images) ? product.images : [];
    if (!wrap || !img || !prev || !next || images.length === 0) {
      if (wrap) wrap.hidden = true;
      return;
    }

    const arrowSvg = getArrowSvg();
    prev.innerHTML = arrowSvg;
    next.innerHTML = arrowSvg;

    let index = 0;

    const normalizeUrl = (u) => {
      if (typeof u !== "string") return "";

      let url = u.startsWith("//") ? `https:${u}` : u;
      url += url.includes("?") ? "&width=1200" : "?width=1200";

      return url;
    };

    const render = () => {
      const total = images.length;
      index = (index % total + total) % total;

      img.src = normalizeUrl(images[index]);
      img.alt = product.title || "";

      prev.disabled = false;
      next.disabled = false;
    };

    prev.onclick = () => {
      index -= 1;
      render();
    };

    next.onclick = () => {
      index += 1;
      render();
    };

    wrap.hidden = false;
    render();
  };

  const updateDrawerPrice = (drawer, variant) => {
    const priceEl = drawer.querySelector("#lv-qa-price");
    if (!priceEl || !variant) return;

    const price = formatMoneyIntl(variant.price);

    if (variant.compare_at_price && variant.compare_at_price > variant.price) {
      const compare = formatMoneyIntl(variant.compare_at_price);
      priceEl.innerHTML = `<s style="opacity:.6;margin-right:8px;">${compare}</s>${price}`;
    } else {
      priceEl.textContent = price;
    }
  };

  const renderVariantPills = (product) => {
    const sizeOptionIndex = (product.options || []).findIndex((o) => /talla|size/i.test(o));
    const wrap = document.createElement("div");
    wrap.className = "lv-qa-opt";

    (product.variants || []).forEach((v) => {
      const label =
        sizeOptionIndex === 0 ? (v.option1 || v.title) :
        sizeOptionIndex === 1 ? (v.option2 || v.title) :
        sizeOptionIndex === 2 ? (v.option3 || v.title) :
        v.title;


      const b = document.createElement("button");
      b.type = "button";
      b.className = "lv-qa-pill";
      b.textContent = label;
      b.setAttribute("aria-pressed", "false");

      if (!v.available) {
        b.classList.add("is-disabled");
        b.disabled = true;
      }

      b.addEventListener("click", () => {
        wrap.querySelectorAll(".lv-qa-pill").forEach((x) => x.setAttribute("aria-pressed", "false"));
        b.setAttribute("aria-pressed", "true");

        const drawer = ensureDrawer();
        drawer.dataset.lvSelectedVariant = String(v.id);

        const addBtn = drawer.querySelector("#lv-qa-drawer-add");
        if (addBtn) addBtn.disabled = false;

        updateDrawerPrice(drawer, v);
      });

      wrap.appendChild(b);
    });

    return wrap;
  };

  const openVariantDrawerForHandle = async (handle) => {
    const product = await fetchProductJson(handle);

    const drawer = ensureDrawer();
    const titleEl = drawer.querySelector("#lv-qa-product-title");
    const sizesEl = drawer.querySelector("#lv-qa-sizes");
    const priceEl = drawer.querySelector("#lv-qa-price");
    const descEl  = drawer.querySelector("#lv-qa-desc");
    const addBtn  = drawer.querySelector("#lv-qa-drawer-add");
    const initialVariant =
      (product.variants || []).find(v => v.available) ||
      (product.variants || [])[0];

    updateDrawerPrice(drawer, initialVariant);
    setupGallery(drawer, product);

    if (titleEl) titleEl.textContent = product.title || "";

    if (sizesEl) {
      sizesEl.innerHTML = "";
      sizesEl.appendChild(renderVariantPills(product));
      // sizesEl.replaceWith(renderVariantPills(product));
    }
    
    if (descEl) {
      descEl.innerHTML = product.description || "";
    }

    if (addBtn) addBtn.disabled = true;
    drawer.dataset.lvSelectedVariant = "";

    openDrawer();
  };

  // Click handler
  document.addEventListener("click", async (e) => {
    const btn = e.target.closest(".lv-quickadd");
    if (!btn) return;

    e.preventDefault();

    const available = btn.dataset.available === "true";
    if (!available) return;

    const requiresOptions = btn.dataset.requiresOptions === "true";
    const handle = btn.dataset.productHandle;
    const variantId = btn.dataset.variantId;

    btn.disabled = true;

    try {
      if (!requiresOptions) {
        await postAddToCart(variantId, 1);
      } else {
        await openVariantDrawerForHandle(handle);
      }
    } catch (err) {
      console.error(err);
      alert(err?.message || "Error");
    } finally {
      btn.disabled = false;
    }
  });

  document.addEventListener("click", async (e) => {
    const addBtn = e.target.closest("#lv-qa-drawer-add");
    if (!addBtn) return;

    const drawer = ensureDrawer();
    const selectedVariant = drawer.dataset.lvSelectedVariant;

    if (!selectedVariant) return;

    addBtn.disabled = true;

    try {
      await postAddToCart(selectedVariant, 1);
      closeDrawer();
    } catch (err) {
      console.error(err);
      alert(err?.message || "Error");
      addBtn.disabled = false;
    }
  });

})();

(() => {
  const drawer = document.getElementById("menu-drawer");
  if (!drawer) return;

  drawer.querySelectorAll("li > a").forEach(a => {
    if (a.textContent.trim().includes("lv-nav-sp")) {
      const li = a.closest("li");
      if (!li) return;

      li.classList.add("lv-nav-spacer");
      a.style.display = "none";
    }
  });
})();
(() => {
  const btn = document.querySelector(".header__icon--menu");
  const header = document.getElementById("shopify-section-header");
  if (!btn || !header) return;

  const root = document.documentElement;
  const mqMobile = window.matchMedia("(max-width: 989px)");

  const getBorderOffset = () => {
    const wrap = header.querySelector(".header-wrapper") || header.closest(".header-wrapper");
    return wrap && wrap.classList.contains("header-wrapper--border-bottom") ? 1 : 0;
  };

  let raf = 0;
  let listening = false;

  let lastHeaderBottom = null;
  let lastVH = null;

  const updateVars = () => {
    raf = 0;

    const borderOffset = getBorderOffset();
    const bottom = Math.max(0, Math.round(header.getBoundingClientRect().bottom - borderOffset));

    if (bottom !== lastHeaderBottom) {
      lastHeaderBottom = bottom;
      root.style.setProperty("--header-bottom-position", `${bottom}px`);
    }

    if (mqMobile.matches) {
      const vv = window.visualViewport;
      const vh = Math.max(0, Math.round((vv?.height ?? window.innerHeight) || 0));

      if (vh && vh !== lastVH) {
        lastVH = vh;
        root.style.setProperty("--viewport-height", `${vh}px`);
      }
    } else {
      if (lastVH !== null) {
        lastVH = null;
        root.style.removeProperty("--viewport-height");
      }
    }

  };

  const requestUpdate = () => {
    if (raf) return;
    raf = requestAnimationFrame(updateVars);
  };

  const addListeners = () => {
    if (listening) return;
    listening = true;

    window.addEventListener("resize", requestUpdate, { passive: true });
    window.addEventListener("scroll", requestUpdate, { passive: true, capture: true });

    if (window.visualViewport) {
      window.visualViewport.addEventListener("resize", requestUpdate, { passive: true });
      window.visualViewport.addEventListener("scroll", requestUpdate, { passive: true });
    }

    mqMobile.addEventListener?.("change", requestUpdate);
  };

  const removeListeners = () => {
    if (!listening) return;
    listening = false;

    window.removeEventListener("resize", requestUpdate);
    window.removeEventListener("scroll", requestUpdate, true);

    if (window.visualViewport) {
      window.visualViewport.removeEventListener("resize", requestUpdate);
      window.visualViewport.removeEventListener("scroll", requestUpdate);
    }

    mqMobile.removeEventListener?.("change", requestUpdate);
  };

  const isOpen = () => btn.getAttribute("aria-expanded") === "true";

  const onOpen = () => {
    requestUpdate();
    setTimeout(requestUpdate, 60);
    setTimeout(requestUpdate, 250);
    addListeners();
  };

  const onClose = () => {
    removeListeners();
    lastHeaderBottom = null;
    lastVH = null;
    requestUpdate();
  };

  const sync = () => (isOpen() ? onOpen() : onClose());

  sync();

  const obs = new MutationObserver(sync);
  obs.observe(btn, { attributes: true, attributeFilter: ["aria-expanded"] });
})();
